'use strict';

var _faAngleLeft = require('@fortawesome/pro-solid-svg-icons/faAngleLeft');

var _faCalendarAlt = require('@fortawesome/pro-regular-svg-icons/faCalendarAlt');

var _faCameraAlt = require('@fortawesome/pro-solid-svg-icons/faCameraAlt');

var _faCaretDown = require('@fortawesome/pro-solid-svg-icons/faCaretDown');

var _faCaretLeft = require('@fortawesome/pro-solid-svg-icons/faCaretLeft');

var _faCaretRight = require('@fortawesome/pro-solid-svg-icons/faCaretRight');

var _faCaretUp = require('@fortawesome/pro-solid-svg-icons/faCaretUp');

var _faCheckCircle = require('@fortawesome/pro-solid-svg-icons/faCheckCircle');

var _faChevronLeft = require('@fortawesome/pro-solid-svg-icons/faChevronLeft');

var _faChevronRight = require('@fortawesome/pro-solid-svg-icons/faChevronRight');

var _faClock = require('@fortawesome/pro-regular-svg-icons/faClock');

var _faEnvelope = require('@fortawesome/pro-solid-svg-icons/faEnvelope');

var _faExclamationCircle = require('@fortawesome/pro-solid-svg-icons/faExclamationCircle');

var _faExclamationTriangle = require('@fortawesome/pro-solid-svg-icons/faExclamationTriangle');

var _faExpand = require('@fortawesome/pro-regular-svg-icons/faExpand');

var _faEye = require('@fortawesome/pro-regular-svg-icons/faEye');

var _faEyeSlash = require('@fortawesome/pro-regular-svg-icons/faEyeSlash');

var _faFacebookF = require('@fortawesome/free-brands-svg-icons/faFacebookF');

var _faHeart = require('@fortawesome/pro-regular-svg-icons/faHeart');

var _faHeart2 = require('@fortawesome/pro-solid-svg-icons/faHeart');

var _faHourglassStart = require('@fortawesome/pro-regular-svg-icons/faHourglassStart');

var _faImage = require('@fortawesome/pro-light-svg-icons/faImage');

var _faLightbulb = require('@fortawesome/pro-light-svg-icons/faLightbulb');

var _faLock = require('@fortawesome/pro-solid-svg-icons/faLock');

var _faMobileAlt = require('@fortawesome/pro-solid-svg-icons/faMobileAlt');

var _faPinterest = require('@fortawesome/free-brands-svg-icons/faPinterest');

var _faPlay = require('@fortawesome/pro-solid-svg-icons/faPlay');

var _faPlayCircle = require('@fortawesome/pro-solid-svg-icons/faPlayCircle');

var _faQuestionCircle = require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');

var _faSearch = require('@fortawesome/pro-solid-svg-icons/faSearch');

var _faSpinner = require('@fortawesome/pro-solid-svg-icons/faSpinner');

var _faSpinnerThird = require('@fortawesome/pro-light-svg-icons/faSpinnerThird');

var _faUsdCircle = require('@fortawesome/pro-solid-svg-icons/faUsdCircle');

var _faTachometerAlt = require('@fortawesome/pro-solid-svg-icons/faTachometerAlt');

var _faTimes = require('@fortawesome/pro-solid-svg-icons/faTimes');

var _faTwitter = require('@fortawesome/free-brands-svg-icons/faTwitter');

var _faUsdCircle2 = require('@fortawesome/pro-regular-svg-icons/faUsdCircle');

var _fontawesomeSvgCore = require('@fortawesome/fontawesome-svg-core');

_fontawesomeSvgCore.library.add(_faAngleLeft.faAngleLeft, _faCalendarAlt.faCalendarAlt, _faCameraAlt.faCameraAlt, _faCaretDown.faCaretDown, _faCaretLeft.faCaretLeft, _faCaretRight.faCaretRight, _faCaretUp.faCaretUp, _faCheckCircle.faCheckCircle, _faChevronLeft.faChevronLeft, _faChevronRight.faChevronRight, _faClock.faClock, _faEnvelope.faEnvelope, _faExclamationCircle.faExclamationCircle, _faExclamationTriangle.faExclamationTriangle, _faExpand.faExpand, _faEye.faEye, _faEyeSlash.faEyeSlash, _faFacebookF.faFacebookF, _faHeart.faHeart, _faHeart2.faHeart, _faHourglassStart.faHourglassStart, _faImage.faImage, _faLightbulb.faLightbulb, _faLock.faLock, _faMobileAlt.faMobileAlt, _faPinterest.faPinterest, _faPlay.faPlay, _faPlayCircle.faPlayCircle, _faQuestionCircle.faQuestionCircle, _faSearch.faSearch, _faSpinner.faSpinner, _faSpinnerThird.faSpinnerThird, _faUsdCircle.faUsdCircle, _faTachometerAlt.faTachometerAlt, _faTimes.faTimes, _faTwitter.faTwitter, _faUsdCircle2.faUsdCircle);


//////////////////
// WEBPACK FOOTER
// ./src/utils/fontAwesomeLibrary.js
// module id = KWyj
// module chunks = 60